import { useRef } from "react";
import { isEmpty } from "lodash";

import { BoxedContent } from "@/components/common";
import { DynamicFormContainer } from "@/components/dynamic";
import dynamicObjectMap from "@/utils/maps/dynamicObjectMap";

function SupplierItemForm() {
  const ref = useRef(null);

  const onStateChange = (key, value) => {
    if (key === "supplier") {
      const formState = ref.current.getState();
      const { detail, detailTable } = formState;

      if (detailTable) {
        ref.current.setFormValue("detailTable", {
          ...detailTable,
          supplier: value,
        });
      }

      if (detail) {
        const itemMapping = detail.map((item) => ({
          ...item,
          supplier: value,
        }));
        ref.current.setFormState({
          detail: itemMapping,
        });
      }
    }
  };

  const onChildStateChange = ({
    index,
    key,
    value,
    parentField,
    parentFieldType,
  }) => {
    const formState = ref.current.getState();
    const stateKey = `${parentField}${parentFieldType}`;
    let parentFieldState = formState[stateKey] ?? {};

    if (index > -1) {
      parentFieldState = formState[parentField][index];
    }

    if (parentField === "detail") {
      switch (key) {
        case "item":
          parentFieldState[key] = value;
          if (value) {
            const { unitOfMeasure } = value;
            if (!isEmpty(unitOfMeasure)) {
              parentFieldState.unitOfMeasure = {
                label: unitOfMeasure.name,
                value: unitOfMeasure.id,
              };
            }
          }
          break;
        default:
          break;
      }
    }
  };

  return (
    <BoxedContent>
      <DynamicFormContainer
        ref={ref}
        objectName={dynamicObjectMap.get("SupplierItemObjectName")}
        showHeader
        onStateChange={onStateChange}
        onChildStateChange={onChildStateChange}
      />
    </BoxedContent>
  );
}

export default SupplierItemForm;
